"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Box, forwardRef } from "@chakra-ui/react";
import { Slider } from "../Slider";
import { NumberInput } from "../../atoms/NumberInput";
import { InputVariant } from "../../atoms/Input";
const SliderInputNumber = forwardRef((_a, ref) => {
    var { value, onChange, title, helpText, helpTextIcon, step, min, max, variant = InputVariant.FILLED, sliderVisible = true, isDisabled = false } = _a, rest = __rest(_a, ["value", "onChange", "title", "helpText", "helpTextIcon", "step", "min", "max", "variant", "sliderVisible", "isDisabled"]);
    return (_jsxs(Flex, Object.assign({ className: "plx-slider-number-input", ref: ref, flexDirection: "column", pb: variant !== InputVariant.READONLY ? "6" : "0", width: "100%" }, { children: [_jsx(Box, Object.assign({ minW: ["280px", "280px", "320px"], color: "semantic.text.primary" }, { children: _jsx(NumberInput, Object.assign({ value: value, onChange: onChange, title: title, helpText: helpText, helpTextIcon: helpTextIcon, variant: variant, step: step, disabled: isDisabled, sx: {
                        input: {
                            minWidth: "24",
                        },
                    } }, rest)) })), sliderVisible && variant !== InputVariant.READONLY ? (_jsx(Box, Object.assign({ px: "2" }, { children: _jsx(Slider, { value: typeof value === "string" ? parseInt(value, 10) : value, onChange: (newValue = 0) => onChange && onChange(newValue.toString(), newValue), focusThumbOnChange: false, step: step, min: min, max: max, isDisabled: isDisabled }) }))) : null] })));
});
SliderInputNumber.displayName = "SliderInputNumber";
export default SliderInputNumber;
//# sourceMappingURL=SliderInputNumber.js.map